module.exports = __webpack_public_path__ + "6c8b479e7b2fcbd1d74d626f8f9f346f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/mug-black-design-resized.png
// module id = 787
// module chunks = 0